<style src="./AtmMap.scss" lang="scss"></style>
<template>
  <section class="wrapper wrapper-content animated fadeIn AtmMap">
    <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

    <ul class="atmlist">
      <Terminal
        v-for="(terminal, terminalIdx) in terminals"
        :key="terminalIdx"
        :terminalInfo="terminal"
      />
    </ul>
  </section>
</template>

<script>
import Spinner from '../../components/Spinner';
import Terminal from './terminal/Terminal.vue';

let refreshIntervalInstance = null;
let refreshIntervalTime = 5000;

export default {
  name: 'AtmMap',
  components: { Spinner, Terminal },
  data() {
    return {
      showSpinner: false,
      terminals: [],
    };
  },
  mounted() {
    this.refreshRoutine();
  },
  beforeUnmount() {
    clearInterval(refreshIntervalInstance);
  },
  methods: {
    refreshRoutine() {
      if (refreshIntervalInstance) {
        clearInterval(refreshIntervalInstance);
      }
      refreshIntervalInstance = setInterval(() => {
        this.loadAtms();
      }, refreshIntervalTime);
    },
    async loadAtms() {
      try {
        const allAtm = await this.$store.dispatch('ATM/GetAllAtm');
        this.terminals = allAtm.state;
      } catch (error) {
        console.error('Error loading ATMs:', error);
      } finally {
        this.refreshRoutine();
      }
    },
  },
};
</script>
